var byTheNumbersHandler = {
	$numbers: [],

	init: function() {
		var $numberCarousel = $('.by-the-number-carousel');
		if ($numberCarousel.length > 0) {
			$numberCarousel.each(function() {
				var $current = $(this);
				var $prev = $current.prev();
				if (Foundation.MediaQuery.is('medium')) {
					$current.css('margin-top', -1 * $prev.outerHeight(true));
				} else {
					$current.css('margin-top', $prev.outerHeight(true));
				}
				if ($current.find('.carousel-cell').length > 1) {
					$current.flickity({
						wrapAround: true,
						pageDots: true,
						fullscreen: false,
						autoPlay: 4000,
						imagesLoaded: true,
					});	
				}
			});
		}
		this.$numbers = $('.by-the-numbers-container .number');
		if (this.$numbers.length > 0) {
			this.$numbers.each(function() {
				var $currentNumber = $(this);
				var numberString = $currentNumber.html().trim();
				var number = numberString;
				if (numberString.indexOf('%') == -1 || /^\d+$/.test(numberString)) {
					number = parseInt(numberString);
				}
				var hasDollar = false;
				if (isNaN(number)) {
					// might be dollar value
					if (numberString[0] == '$') {
						hasDollar = true;
						if (/^\d+$/.test(numberString.substring(1))) {
							number = parseInt(numberString.substring(1));
						} else {
							number = parseInt('ABCD'); // so it returns NaN
						}
					}
				}
				if (!isNaN(number)) {
					$currentNumber.html((hasDollar ? '$' : '')+number.toLocaleString());
				}
			})
		}
	}
}